(module =>{
    "use strict";

    module.component('saveGridState', {
        template: require('./saveGridStateComponent.html'),
        bindings: {
            close: '&',
            dismiss: '&'
        },
        controller: ['$scope', function(this: $TSFixMe, $scope: $TSFixMe) {
            var $ctrl = this;

            $ctrl.$onInit = () =>{};

            $ctrl.ok = function () {
                $ctrl.close({$value: $ctrl.model});
            };
            $ctrl.cancel = function () {
                $ctrl.dismiss({ $value: 'cancel' });
            };
        }]
    })

})(angular.module('topline.modules'));